import {defineMessages} from "react-intl";

export const CommonErrorMessages = defineMessages({
  unknown: {
    id: "app.error.unknown",
    defaultMessage: "Unknown error",
  },
})